<template lang="pug">
div
  pesquisa(
      :cardStyle="cardStyle"
      placeHolder="Informe o nome ou CPF do beneficiário"
      @search="search"
      :isSearchOnChange="true"
  )
  el-card.card(shadow="hover" :style="cardStyle")
    .card-header-financeiro
      .flex
        div
          h3(:class="isBeneficiariosDiferentes ? 'text' : 'titulo' ") Beneficiários
        slot(name="button-adicionar")
    el-table(
      :data="paginatedData[pagina]"
      style="width: 100%"
      @expand-change="collapseOnChange"
      @row-click="toogle"
      ref="table"
    )
      el-table-column(
        type="expand"
      )
        template(slot-scope="props")
          span {{props.row.showGeo}}
          app-visualizar-beneficiario(:beneficiario="props.row", :cadastroOriginal="cadastroOriginal" :isBeneficiariosDiferentes="isBeneficiariosDiferentes")
          app-divider(label="Dependentes",v-if="props.row.pessoa.pessoaFisica.dependentes && props.row.pessoa.pessoaFisica.dependentes.length")
          app-dependentes(
            :dependentes="props.row.pessoa.pessoaFisica.dependentes",
            :protocolo="cadastroOriginal.protocolo"
            v-if="props.row.pessoa.pessoaFisica.dependentes && props.row.pessoa.pessoaFisica.dependentes.length"
          )
          listagem-documentos(
              v-if="props.row.documentos && props.row.documentos.length > 0"
              :documentos="props.row.documentos",
              :protocoloCadastroOriginal="cadastroOriginal.protocolo"
              :idBeneficiario="props.row._id || props.row.id "
              :isBeneficiario="true"
              ownerDocumento="BENEFICIARIO"
              :versaoCadastro = "versaoCadastro"
            )
          div(v-if="isPEAS")
            app-resumo-imovel-beneficiario(:imovel="props.row.imovel" :cadastroOriginal="props.row")
            listagem-documentos(
              v-if="props.row.imovel.documentos && props.row.imovel.documentos.length > 0"
              :documentos="props.row.imovel.documentos",
              :protocoloCadastroOriginal="cadastroOriginal.protocolo"
              ownerDocumento="IMOVEL"
              :versaoCadastro = "versaoCadastro"
            )
            app-resumo-geo(
              :geo="props.row.georreferenciamento",
              :id-mapa="`mapaResumo${props.row.id}`",
              :idCadastro="'' + props.row.id"
              :isCadastroOff="props.row.georreferenciamento.localizacoes.length > 0 && !!props.row.georreferenciamento.localizacoes[0].geometry"
              v-if="beneficiarios.find(beneficiario => props.row.pessoa.pessoaFisica.cpf === beneficiario.pessoa.pessoaFisica.cpf)",
              :exibeDocumentos="false",
              :isVisualizarCadastro="true",
              :isGeoBeneficiario="true",
              :showMapa="props.row.georreferenciamento.localizacoes.length > 0"
            )
            informacoes-responsavel-geo(
              v-if="props.row.georreferenciamento.responsavel"
              :responsavel="props.row.georreferenciamento.responsavel",
            )
            listagem-documentos(
              v-if="props.row.georreferenciamento.documentos && props.row.georreferenciamento.documentos.length > 0"
              :documentos="props.row.georreferenciamento.documentos",
              :protocoloCadastroOriginal="cadastroOriginal.protocolo",
              ownerDocumento="GEO-BENEFICIARIO"
              :versaoCadastro = "versaoCadastro"
            )
      el-table-column(
        label="CPF"
        prop="pessoa.pessoaFisica.cpf"
      )
      el-table-column(
        label="Nome"
        prop="pessoa.pessoaFisica.nome"
      )
      el-table-column(
        prop='pessoa.pessoaFisica.nomeDaMae',
        label='Nome da Mãe'
      )
      el-table-column(
        label='Ações'
        v-if="canRemove"
      )
        template(slot-scope='scope')
          app-action-button(
            v-if="canRemove"
            icone="times",
            cor="#CF0021",
            method="removeBeneficiario",
            @click="removeBeneficiario(scope.row.pessoa.pessoaFisica.cpf)",
            text="Remover"
          )
    .pagination
      el-pagination(
        layout="prev, pager, next",
        :total="totalElements",
        :page-size="CONFIGS.TAMANHO_PAGINACAO",
        :current-page.async="pagina + 1",
        @current-change="alterarPagina"
      )
</template>
<script>
import AppVisualizarBeneficiario from '@/components/AppVisualizarBeneficiario.vue'
import InformacoesResponsavelGeo from '../informacoesCadastro/InformacoesResponsavelGeo.vue'
import AppResumoGeo from '@/components/resumo/AppResumoGeo.vue'
import AppActionButton from '@/components/AppActionButton.vue'
import ListagemDocumentos from '@/components/informacoesCadastro/ListagemDocumentos.vue'
import AppResumoImovelBeneficiario from '@/components/resumo/AppResumoImovelBeneficiario.vue'
import Pesquisa from '@/components/Pesquisa.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CONFIGS from '@/constants/configs.js'

export default {
  components: {
    AppVisualizarBeneficiario,
    ListagemDocumentos,
    AppResumoImovelBeneficiario,
    AppActionButton,
    Pesquisa,
    InformacoesResponsavelGeo,
    AppResumoGeo
  },

  props: {
    beneficiarios: {
      type: Array,
      required: true
    },
    cadastroOriginal: {
      type: Object,
      required: true
    },
    canRemove: {
      type: Boolean,
      default: false
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    },
    isBeneficiariosDiferentes: {
      type: Boolean,
      default: false
    }
  },

  mixins: [AppNotificacao],

  data () {
    return {
      CONFIGS,
      cardStyle: 'margin: 2% 0 2% 0;',
      allData: [],
      allDataWithoutRemoveds: [],
      paginatedData: [[]],
      pagina: 0,
      totalElements: 0
    }
  },

  created () {
    this.init()
  },

  computed: {
    isPEAS () {
      return this.cadastroOriginal.tipo === 'PEAS'
    }
  },

  methods: {
    init () {
      this.allData = [...this.beneficiarios]
      this.allDataWithoutRemoveds = [...this.beneficiarios]
      this.totalElements = this.allData.length
    },

    paginateArray (array) {
      return new Array(Math.ceil(array.length / CONFIGS.TAMANHO_PAGINACAO))
        .fill()
        .map(_ => array.splice(0, CONFIGS.TAMANHO_PAGINACAO))
    },

    search (searchField) {
      if (searchField) {
        this.allData = this.allDataWithoutRemoveds.filter(beneficiario => {
          return (
            !searchField ||
            (beneficiario.pessoa.pessoaFisica.nome &&
              beneficiario.pessoa.pessoaFisica.nome
                .toLowerCase()
                .includes(searchField.toLowerCase())) ||
            (beneficiario.pessoa.pessoaFisica.cpf &&
              (beneficiario.pessoa.pessoaFisica.cpf
                .toLowerCase()
                .includes(searchField.toLowerCase()) ||
                beneficiario.pessoa.pessoaFisica.cpf
                  .toLowerCase()
                  .replaceAll('.', '')
                  .replaceAll('-', '')
                  .includes(searchField.toLowerCase())))
          )
        })
      } else {
        this.allData = [...this.allDataWithoutRemoveds]
      }
    },

    alterarPagina (newPage) {
      this.pagina = newPage - 1
    },

    removeBeneficiario (beneficiarioCPF) {
      if (this.allDataWithoutRemoveds.length === 1) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Não é possível excluir todos os beneficiários'
        )
        return
      }
      this.confirmBox(
        `Tem certeza que deseja remover o beneficiário de CPF ${beneficiarioCPF}?`,
        this.$messages.TITULO_WARNING,
        () => {
          this.allDataWithoutRemoveds = this.allDataWithoutRemoveds.filter(
            beneficiario =>
              beneficiario.pessoa.pessoaFisica.cpf !== beneficiarioCPF
          )
          this.allData = [...this.allDataWithoutRemoveds]
          this.$emit('updateBeneficiariosLista', this.allData)
        },
        () => {}
      )
    },

    toogle (row, column, event) {
      if (column.label !== 'Ações') this.$refs['table'].toggleRowExpansion(row)
    },

    collapseOnChange (row, expandedRows) {
      if (expandedRows.length > 1) {
        expandedRows.forEach(element => {
          if (element.pessoa.pessoaFisica.cpf !== row.pessoa.pessoaFisica.cpf) {
            this.$refs['table'].toggleRowExpansion(element, false)
          }
        })
      }
    }
  },

  watch: {
    beneficiarios: {
      handler (val, oldVal) {
        if (val.length >= 0) {
          this.init()
        }
      },
      deep: true
    },

    allData: {
      handler (val, oldVal) {
        if (this.allData.length) {
          this.totalElements = this.allData.length
          this.paginatedData = this.paginateArray(this.allData)
          this.pagina = 0
        } else if (this.allData.length === 0 && val !== oldVal) {
          this.paginatedData = [[]]
          this.totalElements = 0
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.label {
  font-size: 16px;
}

/deep/ .el-collapse-item__header {
  font-size: 16px;
  color: $font-dark-color;
  font-weight: bold;
}

/deep/ .el-collapse-item__content {
  font-size: unset !important;
  color: unset !important;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.text{
    color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesBeneficiarios.vue